"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The FeedbackParams model module.
 * @module model/FeedbackParams
 * @version 1.1.3-alpha.1
 */
class FeedbackParams {
  /**
   * Constructs a new <code>FeedbackParams</code>.
   * @alias module:model/FeedbackParams
   */
  constructor() {
    FeedbackParams.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>FeedbackParams</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FeedbackParams} obj Optional instance to populate.
   * @return {module:model/FeedbackParams} The populated <code>FeedbackParams</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new FeedbackParams();
      if (data.hasOwnProperty('comments')) {
        obj['comments'] = _ApiClient.default.convertToType(data['comments'], 'String');
      }
      if (data.hasOwnProperty('ideas')) {
        obj['ideas'] = _ApiClient.default.convertToType(data['ideas'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>FeedbackParams</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FeedbackParams</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['comments'] && !(typeof data['comments'] === 'string' || data['comments'] instanceof String)) {
      throw new Error("Expected the field `comments` to be a primitive type in the JSON string but got " + data['comments']);
    }
    // ensure the json data is a string
    if (data['ideas'] && !(typeof data['ideas'] === 'string' || data['ideas'] instanceof String)) {
      throw new Error("Expected the field `ideas` to be a primitive type in the JSON string but got " + data['ideas']);
    }
    return true;
  }
}

/**
 * @member {String} comments
 */
FeedbackParams.prototype['comments'] = undefined;

/**
 * @member {String} ideas
 */
FeedbackParams.prototype['ideas'] = undefined;
var _default = FeedbackParams;
exports.default = _default;